<div class="row mx-1">
  <div [ngClass]="isModal?'col-12':'col-11'">
    <app-page-breadcrumb [pageInfo]="pageInfo" [isModal]="isModal"></app-page-breadcrumb>

  </div>
  @if (staffData.status==1&&!isModal) {
  <div class="col-1 d-flex  justify-content-center align-items-center pe-2  pt-1">
    <p-button (onClick)="goEdit()" icon="pi pi-pencil" label="Edit" severity="warning" size="small"
      class="p-btn-white" />
  </div>
  }



</div>
<div class="card info_view">
  <table class="table">
    <th><b> Staff Information</b></th>
  </table>
  <div class="img_view d-flex ">
    <label for="">Profile:</label>
    <img imageLoad src="staffData?.profile_img_path" alt="Staff Profile Image" style="height: 4rem;width: 4rem">
  </div>
  <!-- your-component.template.html -->
  <!-- <app-image-fallback [imageUrl]="staffData.profile_img_path"></app-image-fallback> -->
  <info-view [sourceData]="staffData" [formData]="staffFormData"></info-view>
  <table class="table">
    <th><b> Other Information</b></th>
  </table>
  <info-view [sourceData]="staffData" [mapData]="otherInfo"></info-view>
  @if (!isModal) {
  <hr>
  <div class="text-center gap-2" style="display: flex;flex-direction:row;justify-content: center">
    <p-button goBack label="Cancel" (click)="goBack()" icon="pi pi-times" [loading]="dataLoading" size="large"
      severity="danger"></p-button>
  </div>}
</div>